/** @module csi/task/TaskDueDateOrPriorityAction */
define([
	"dojo/_base/declare",
	"csi/heading/AttributeAction",
	"./util"
], function(declare, AttributeAction, TaskUtil) {

	return declare(AttributeAction, {
		/**
		 * Enable editing if the user is Workflow Administrator or Assignee
		 * @param {Context} ctx
		 */
		hasAccess: function(ctx) {
			return this.inherited(arguments) && TaskUtil.canEditDueDateOrPriority(ctx);
		}
	});
});
